module.exports = __webpack_public_path__ + "img/rep-ganz.c37ce828.jpg";